import { SET_ACCESS_CONTROL, CLEAR_ACCESS_CONTROL } from 'js/constants/actionTypes';

export const setAccessControl = (payload) => {
  return {
    type: SET_ACCESS_CONTROL,
    payload,
  };
};

export const clearAccessControl = () => {
  return {
    type: CLEAR_ACCESS_CONTROL,
  };
};
